import { execOnLoad } from '@general/helpers';
import './localization-selector.scss';

if (!window.dAgency) window.dAgency = {};

window.dAgency.initLocalizationSelector = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const customSelectContainers =
    sectionContainer.querySelectorAll('.custom-select');

  customSelectContainers.forEach((container) => {
    new CustomSelect(container);
  });
};

class CustomSelect {
  constructor(container) {
    this.container = container;
    this.selectButton = container.querySelector('.select-button');
    this.optionsContainer = container.querySelector('.options-container');
    this.options = container.querySelectorAll('.option');
    this.selectedText = container.querySelector('#selectedText');
    this.nativeSelect = container.querySelector('.native-select');
    this.isOpen = false;

    if (this.selectButton && this.optionsContainer) {
      this.init();
    }
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Toggle dropdown
    this.selectButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });

    // Select option
    this.options.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectOption(option);
      });
    });

    // Close on outside click
    document.addEventListener('click', () => {
      if (this.isOpen) this.close();
    });

    // Keyboard navigation
    this.selectButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggle();
      }
    });
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.selectButton.classList.add('open');
    this.optionsContainer.classList.add('open');
  }

  close() {
    this.isOpen = false;
    this.selectButton.classList.remove('open');
    this.optionsContainer.classList.remove('open');
  }

  selectOption(selectedOption) {
    // Deselect previous
    this.options.forEach((option) => {
      option.classList.remove('selected');
    });

    selectedOption.classList.add('selected');
    this.selectedText.textContent = selectedOption.textContent;

    const value = selectedOption.dataset.value;
    this.nativeSelect.value = value;

    this.close();
  }
}

execOnLoad(
  window.dAgency.initLocalizationSelector,
  '.localization-selector__section',
);
